var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('v-container',{class:{
        'py-12': _vm.$vuetify.breakpoint.mdAndUp,
        'pa-4': !_vm.$vuetify.breakpoint.mdAndUp
      },staticStyle:{"height":"100%"}},[_c('router-link',{attrs:{"to":{ name: _vm.$constants.ROUTE_NAME.HOME }}},[_c('img',{class:{
            'mb-10': _vm.$vuetify.breakpoint.mdAndUp,
            'mb-4': !_vm.$vuetify.breakpoint.mdAndUp
          },attrs:{"src":require("@/assets/oly-logo.png")}})]),_c('router-view',{staticStyle:{"height":"100%"}})],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }